function onClickAccordion(id, section) {

    for(let element of document.getElementById(id).querySelectorAll('.accordion-content')) {
        if(element.attributes['section'].value == section) {
            element.classList.remove('hidden')
        } else {
            element.classList.add('hidden')
        }
    }
}

window.onClickAccordion = onClickAccordion
